var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{staticClass:"margin-bottom-15",attrs:{"label":"Моделі","prop":"models"}},[_c('CourceModelsDays',{attrs:{"eventForm":_vm.eventForm,"dateArray":_vm.eventForm.dateStart && !_vm.eventForm.dateEnd
        ? [_vm.eventForm.dateStart]
        : _vm.eventForm.dateArray}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }